import type { IconData } from '@stacksjs/iconify-core'

export const pk4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGtK1cVinP\"><path fill-opacity=\".7\" d=\"M-52.3 0h682.6v512H-52.3z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGtK1cVinP)\" transform=\"translate(49)scale(.9375)\"><path fill=\"#0c590b\" d=\"M-95 0h768v512H-95z\"/><path fill=\"#fff\" d=\"M-95 0H97.5v512H-95z\"/><g fill=\"#fff\"><path d=\"m403.7 225.4l-31.2-6.6l-16.4 27.3l-3.4-31.6l-31-7.2l29-13l-2.7-31.7l21.4 23.6l29.3-12.4l-15.9 27.6l21 24z\"/><path d=\"M415.4 306a121 121 0 0 1-161.3 59.4a122 122 0 0 1-59.5-162.1A119 119 0 0 1 266 139a156 156 0 0 0-11.8 10.9A112.3 112.3 0 0 0 415.5 306z\"/></g></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default pk4x3
